import { createScrollToggle } from './create-toggle-scroll';

const SINGLETON_INSTANCE: {
  disableScroll: (() => void) | null;
  enableScroll: (() => void) | null;
} = {
  disableScroll: null,
  enableScroll: null,
};

export function toggleScroll() {
  if (!SINGLETON_INSTANCE.disableScroll) {
    const { disableScroll, enableScroll } = createScrollToggle();
    Reflect.set(SINGLETON_INSTANCE, 'disableScroll', disableScroll);
    Reflect.set(SINGLETON_INSTANCE, 'enableScroll', enableScroll);
  }

  return SINGLETON_INSTANCE as {
    disableScroll(): void;
    enableScroll(): void;
  };
}
